import { render, staticRenderFns } from "./ConnectModalWarningBlock.vue?vue&type=template&id=938435c4&scoped=true&"
import script from "./ConnectModalWarningBlock.vue?vue&type=script&lang=js&"
export * from "./ConnectModalWarningBlock.vue?vue&type=script&lang=js&"
import style0 from "./ConnectModalWarningBlock.vue?vue&type=style&index=0&id=938435c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "938435c4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('938435c4')) {
      api.createRecord('938435c4', component.options)
    } else {
      api.reload('938435c4', component.options)
    }
    module.hot.accept("./ConnectModalWarningBlock.vue?vue&type=template&id=938435c4&scoped=true&", function () {
      api.rerender('938435c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/service/ConnectModalWarningBlock.vue"
export default component.exports